(() => {
  const MQ = window.matchMedia("(max-width: 749px)");

  function getOptions(sliderEl) {
    const jsonEl = sliderEl.querySelector(".bd-splide-options");
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function mountSlider(sliderEl) {
    if (!sliderEl || sliderEl.__splideMounted) return;

    const options = getOptions(sliderEl);
    if (!options || typeof Splide === "undefined") return;

    // If autoScroll is enabled in options, mount with Extensions (provided by the AutoScroll script)
    const extensions = (window.splide && window.splide.Extensions) ? window.splide.Extensions : {};

    sliderEl.__splide = new Splide(sliderEl, options);
    sliderEl.__splide.mount(extensions);

    sliderEl.__splideMounted = true;
  }

  function destroySlider(sliderEl) {
    if (!sliderEl || !sliderEl.__splideMounted || !sliderEl.__splide) return;
    sliderEl.__splide.destroy(true);
    sliderEl.__splide = null;
    sliderEl.__splideMounted = false;
  }

  function handleSection(section) {
    const sliderEl = section.querySelector(".bd-editorial-splide");
    if (!sliderEl) return;

    const apply = () => {
      if (MQ.matches) mountSlider(sliderEl);
      else destroySlider(sliderEl);
    };

    apply();

    // Re-apply on breakpoint changes
    if (MQ.addEventListener) MQ.addEventListener("change", apply);
    else MQ.addListener(apply); // Safari fallback
  }

  function init(root = document) {
    root.querySelectorAll("[data-editorial-splide-section]").forEach(handleSection);
  }

  document.addEventListener("DOMContentLoaded", () => init());

  // Theme editor support
  document.addEventListener("shopify:section:load", (e) => init(e.target));
  document.addEventListener("shopify:section:unload", (e) => {
    const section = e.target;
    const sliderEl = section.querySelector(".bd-editorial-splide");
    destroySlider(sliderEl);
  });
})();